export enum PRODUCT_SUPPLIER_DOMAIN {
  VALUE = 'value',
}

export const PRODUCT_SUPPLIER_DOMAIN_KEY = 'productSupplier';
